import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { history } from '../../../../configuration/store';
import { getJob, getPosition, getAdmin, preferContractType, setProgressionProperties, getProjects } from '../../../../reducers/onboarding';
import Wizard from './../../../../components/wizard';
import { getRequirements } from '../../../../reducers/tenants';
import { getPendingJobRequirement } from '../../../../utilities/requirements';
import { setProgress } from '../../../../reducers/wizard';
import { getSteps } from './steps';
import { getAddresses } from '../../../../reducers/addresses';

class ContractorOnboarding extends React.Component {
    componentDidMount() {
        const { requirements, admin, getAdmin, getJob, getProjects, setProgress, setProgressionProperties, getPosition, getAddresses, role } = this.props;
        let jobRequirement = getPendingJobRequirement(requirements);
        if (!jobRequirement || !jobRequirement.entity_id) {
            return;
        }
        getAddresses(role, addresses => {
            if (addresses && addresses.length > 0) {
                setProgressionProperties({ mailingAddress: addresses[addresses.length - 1] });
            }
        });
        getJob(jobRequirement.entity_id, result => {
            getPosition(result.job.position_id, () => {
                if (!admin) {
                    getAdmin(result.client.admin_id, () => setProgress({ entity: 'job', id: jobRequirement.entity_id }, result.job.progress));
                } else {
                    setProgress({ entity: 'job', id: jobRequirement.entity_id }, result.job.progress);
                }
            });
        });

        getProjects(jobRequirement.entity_id);
    }

    render() {
        const { job, position, admin, addresses } = this.props;
        if (!job || !position || !admin || !addresses) return null;

        return (
            <Wizard
                configuration={{ entity: 'job', id: job.id }}
                getSteps={(controls, progress) => getSteps(controls, progress, { ...this.props, modal: { open: this.onOpen, close: this.onClose } })}
            />
        );
    }
}

ContractorOnboarding.defaultProps = {
    cancel: () => history.push('/')
};
ContractorOnboarding.propTypes = {
    cancel: PropTypes.func
};

const mapStateToProps = state => ({
    role: state.identity.role,
    profile: state.identity.profile,
    job: state.onboarding.job,
    admin: state.onboarding.admin,
    client: state.onboarding.client,
    address: state.onboarding.address,
    projects: state.onboarding.projects,
    hiring_manager: state.onboarding.hiring_manager,
    position: state.onboarding.position,
    addresses: state.addresses.list,
    progress: state.wizard.progress,
    regime: state.onboarding.progression.regime || (state.jobs.list || [{}])[0].regime
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin,
            getAddresses,
            getJob,
            getRequirements,
            getPosition,
            preferContractType,
            setProgress,
            setProgressionProperties,
            getProjects
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorOnboarding);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/index.jsx